function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11.741 3.803L1 3.805H.85V5.13h10.891l-2.56 2.7-.239.253H10.78l.044-.047L14.11 4.57l.098-.103-.098-.103L10.824.897 10.78.85H8.94l.24.253 2.56 2.7z",
  fill: "#020203",
  stroke: "#000",
  strokeWidth: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.259 11.197L14 11.195h.15V9.87H3.259l2.56-2.7.239-.253H4.22l-.044.047L.89 10.43l-.098.103.098.103 3.285 3.466.044.047H6.06l-.24-.253-2.56-2.7z",
  fill: "#020203",
  stroke: "#000",
  strokeWidth: ".3"
})));